var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketPlaceTopRightLeftBlur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_333_621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1333 82.8338C39.2339 103.762 61.9471 114.989 82.8646 107.909C103.782 100.829 114.983 78.124 107.883 57.1956C100.782 36.2672 78.0688 25.0406 57.1512 32.1204C36.2337 39.2002 25.0328 61.9054 32.1333 82.8338Z",
    fill: "url(#paint0_radial_333_621)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_333_621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3364 75.6166C48.2712 90.1615 63.7463 98.0687 77.901 93.2778C92.0558 88.487 99.5301 72.8123 94.5953 58.2675C89.6606 43.7226 74.1855 35.8154 60.0307 40.6063C45.8759 45.3971 38.4017 61.0718 43.3364 75.6166Z",
    fill: "url(#paint1_radial_333_621)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_333_621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.408 70.0938C63.0614 74.9673 68.3535 77.5805 73.2282 75.9306C78.1029 74.2808 80.7142 68.9925 79.0608 64.1191C77.4073 59.2456 72.1152 56.6324 67.2405 58.2823C62.3658 59.9321 59.7545 65.2204 61.408 70.0938Z",
    fill: "url(#paint2_radial_333_621)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_333_621",
    x: 0,
    y: 0,
    width: 140.016,
    height: 140.029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_333_621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_333_621",
    x: 11.8159,
    y: 9.20691,
    width: 114.3,
    height: 115.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_333_621"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_333_621",
    x: 30.9116,
    y: 27.7878,
    width: 78.6455,
    height: 78.6374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70,
    result: "effect1_foregroundBlur_333_621"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_333_621",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(12.8567 37.8942 37.8746 -12.8191 70.0079 70.0147)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2AC2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AC2D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_333_621",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.93516 26.3358 25.6295 -8.67459 68.9659 66.9421)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2AC2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AC2D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_333_621",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.99386 8.82419 8.82639 -2.98739 70.2344 67.1064)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00160247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketPlaceTopRightLeftBlur);
export default __webpack_public_path__ + "static/media/MarketPlaceTopRightLeftBlur.40469511bb92dd0e9207603f49fd7e05.svg";
export { ForwardRef as ReactComponent };